import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { threeDSWarningFlag as threeDSWarningFlagSelector } from 'ggApp/modules/featureFlag/selectors';
import GatewaySelector from './GatewaySelector';

const enhance = compose(
    connect(
        createStructuredSelector({
            threeDSWarningFlag: threeDSWarningFlagSelector,
        }),
    ),
);

export default enhance(GatewaySelector);
